/** Mirrors backend `DUPLICATE_CONTRACT_CODE` (contract.service.ts) — 409 that the user may confirm past. */
export const DUPLICATE_CONTRACT_CODE = 'EPC_CONTRACT_POSSIBLE_DUPLICATE';

type ApiError = {
  response?: { status?: number; data?: { message?: string; code?: string } };
  message?: string;
};

export function isDuplicateContractError(e: unknown): boolean {
  const err = e as ApiError;
  return err?.response?.status === 409 && err.response?.data?.code === DUPLICATE_CONTRACT_CODE;
}

export function apiErrorMessage(e: unknown, fallback: string): string {
  const err = e as ApiError;
  return err?.response?.data?.message || err?.message || fallback;
}
